const DEFAULT_UNAUTHENTICATED_REDIRECT_PATH = "/";
const NOTES_TO_QUIZ_PATH_PATTERN = /^\/notes-to-quiz\/[^/?#]+$/;

export const getUnauthenticatedRedirectPath = (pathname = "") => {
  if (NOTES_TO_QUIZ_PATH_PATTERN.test(pathname)) {
    return `/login?next=${encodeURIComponent(pathname)}`;
  }

  return DEFAULT_UNAUTHENTICATED_REDIRECT_PATH;
};
